"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyMismatchError = void 0;
exports.currencyAmount = currencyAmount;
exports.sumInCurrency = sumInCurrency;
exports.assertChainCurrency = assertChainCurrency;
const money_1 = require("./money");
class CurrencyMismatchError extends Error {
    constructor(expected, found) {
        super(`Cross-currency arithmetic is not allowed in a chain: expected ${expected}, found ${found}.`);
        this.name = 'CurrencyMismatchError';
    }
}
exports.CurrencyMismatchError = CurrencyMismatchError;
function currencyAmount(amount, currency) {
    return { amount, currency };
}
function sumInCurrency(currency, values) {
    for (const value of values) {
        if (value.currency !== currency)
            throw new CurrencyMismatchError(currency, value.currency);
    }
    return currencyAmount((0, money_1.sumMoney)(values.map((value) => value.amount)), currency);
}
function assertChainCurrency(ledgerKind, ledgerCurrency, documentCurrency) {
    if (ledgerKind === 'overhead' || ledgerKind === 'costs')
        return;
    if (ledgerCurrency === null)
        throw new CurrencyMismatchError(documentCurrency, documentCurrency);
    if (ledgerCurrency !== documentCurrency) {
        throw new CurrencyMismatchError(ledgerCurrency, documentCurrency);
    }
}
//# sourceMappingURL=currency-amount.js.map